import React from "react";

import clsx from "clsx";

import { Tooltip } from "@features/sales-v3/top-level-filters/components/filter-button-active/tooltip";
import { useDesignElementManager } from "@hooks/use-design-element-manager";
import { PLATFORM_NORTHBEAM } from "@north-beam/nb-common";

export interface Filter {
  breakdown: string;
  values: string[];
  total: number;
}

interface Props {
  filter: Filter;
}

export const FilterPill = ({ filter }: Props) => {
  return (
    <Tooltip filter={filter}>
      {filter.breakdown === PLATFORM_NORTHBEAM ? (
        <PlatformFilterPill filter={filter} />
      ) : (
        <GenericFilterPill filter={filter} />
      )}
    </Tooltip>
  );
};

const PlatformFilterPill = ({ filter }: Props) => {
  const { designElementManager } = useDesignElementManager();

  const top = filter.values.slice(0, filter.values.length > 5 ? 3 : 5);
  const rest = filter.values.slice(top.length);

  return (
    <div className="flex">
      {top.map((platform, index) => {
        const designElement = designElementManager.getDesignElement(platform);

        const icon = designElement.getComponent({
          className: clsx("relative", {
            "mr-[-8px]": index < top.length - 1 || rest.length > 0,
          }),
          borderColor: "#C1C5CD",
          size: "30",
        });

        return (
          <div key={platform} style={{ zIndex: top.length - index }}>
            {icon}
          </div>
        );
      })}
      {rest.length > 0 && (
        <div
          className={clsx(
            "text-[9px] bg-interstellar-3 rounded-2xl px-3 flex items-center h-[30px]",
            "border border-v2-secondary",
          )}
        >
          {rest.length} more
        </div>
      )}
    </div>
  );
};

const GenericFilterPill = ({ filter }: Props) => {
  return (
    <div
      className={clsx(
        "text-[11px] bg-interstellar-3 rounded-2xl py-1 px-4 truncate max-w-[120px]",
        "leading-3 h-[30px]",
      )}
    >
      <div className="text-xxxs font-black mb-0.5 overflow-hidden flex">
        <span className="uppercase truncate mr-1">{filter.breakdown}</span>
        <span>
          ({filter.values.length} OF {filter.total})
        </span>
      </div>
      {filter.values.join(", ")}
    </div>
  );
};
